import React, { ReactElement } from 'react'
import { MVP_COLOR_TOKENS } from '../../../utils/constants/color-tokens'

interface IPlayButton {
  size: 'xs' | 'sm' | 'md' | 'lg'
}

const PlayButton = ({ size = 'md' }: IPlayButton): ReactElement => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`play-button play-button--${size}`}
      viewBox="0 0 108 108"
      fill="none"
    >
      <rect width="100" height="100" rx="50" x="4" y="4" fill={MVP_COLOR_TOKENS.paper.hex!} />
      <path
        d="M75.372 52.03c1.504.876 1.504 3.066 0 3.94L44.886 73.696a2.258 2.274 0 0 1-3.386-1.969V36.275a2.259 2.275 0 0 1 3.387-1.97z"
        fill={MVP_COLOR_TOKENS.blue.hex!}
      />
    </svg>

    <style jsx>{`
      .play-button {
        cursor: pointer;

        rect {
          transform-origin: center;
          transition: transform 0.24s, opacity 0.24s;
        }

        &--xs {
          width: 2rem;
          height: 2rem;
        }

        &--sm {
          width: 4rem;
          height: 4rem;
        }

        &--md {
          width: 5rem;
          height: 5rem;
        }

        &--lg {
          width: 6rem;
          height: 6rem;
        }

        &:focus,
        &:hover {
          rect {
            transform: scale(108%);
          }
        }

        &:active {
          rect {
            opacity: 80%;
          }
        }
      }
    `}</style>
  </>
)

export default PlayButton
